import React from "react";
import { BeatLoader } from "react-spinners";

export type TBtnVariant = "default" | "transparent" | "style-with-class";

export interface IAppBtnProps {
  isLoading?: boolean;
  label?: string;
  type?: "submit" | "reset" | "button";
  handleClick?: () => void;
  additionalClassNames?: string[];
  disabled?: boolean;
  variant?: TBtnVariant;
}

export const AppButton: React.FunctionComponent<IAppBtnProps> = ({
  disabled = false,
  isLoading = false,
  label = "submit",
  type = "button",
  variant = "default",
  handleClick,
  additionalClassNames = ["button"],
}) => {
  if (variant === "style-with-class") {
    return (
      <button
        className={`${[additionalClassNames]?.join(" ")} ${
          disabled ? "opacity-50 cursor-not-allowed" : ""
        }`}
        type={type}
        onClick={() => handleClick?.()}
        disabled={disabled}
      >
        {isLoading ? <BeatLoader color="#aaa" /> : label}
      </button>
    );
  }

  if (variant === "transparent") {
    return (
      <button
        className={`${[...additionalClassNames, "transparentButton"]?.join(
          " ",
        )} capitalize ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
        type={type}
        onClick={() => handleClick?.()}
        disabled={disabled}
        style={{ color: disabled ? "#999" : "var(--neutral)" }}
      >
        {isLoading ? <BeatLoader color="#aaa" /> : label}
      </button>
    );
  }

  return (
    <button
      className={`${
        disabled
          ? "bg-gray-300 text-gray-400 cursor-not-allowed opacity-70"
          : "bg-primary text-white hover:bg-primary/90"
      } px-4 py-2 rounded-md font-medium transition-colors ${additionalClassNames?.join(
        " ",
      )}`}
      type={type}
      onClick={() => handleClick?.()}
      disabled={disabled}
    >
      {isLoading ? <BeatLoader color="#fff" /> : label}
    </button>
  );
};
